import {
   CurrentHealthcareProviderConstraintQuery,
   HealthcareProviderConstraint,
} from '@dreryk/egabinet-healthcare-provider-frontend-api';

import { useCqrsGet } from '@dreryk/command-query-react-common';
import { LoaderSpinner, Message, MessageType } from '@dreryk/react-components';

import { dataStorageTranslationKeys } from '../../translations';

type DataStoragePanelLoaderRenderProps = {
   healthcareProviderConstraint: HealthcareProviderConstraint;
};

type DataStoragePanelLoaderProps = {
   readonly children: (renderProps: DataStoragePanelLoaderRenderProps) => JSX.Element;
};

export const DataStoragePanelLoader = (props: DataStoragePanelLoaderProps): JSX.Element => {
   const {
      data: healthcareProviderConstraint,
      loading: healthcareProviderConstraintLoading,
      error: healthcareProviderConstraintError,
   } = useCqrsGet<HealthcareProviderConstraint>(() => new CurrentHealthcareProviderConstraintQuery());

   if (healthcareProviderConstraintLoading) {
      return <LoaderSpinner />;
   }

   if (healthcareProviderConstraintError) {
      return (
         <Message
            testId={'failedToFetchDataStorageInfo'}
            label={dataStorageTranslationKeys.failedToFetchDataStorageInfo}
            type={MessageType.NEGATIVE}
            displayIndicator
         />
      );
   }

   return props.children({
      healthcareProviderConstraint: healthcareProviderConstraint,
   });
};
